import React from 'react';
import { useTranslation } from 'react-i18next';

import WarningNoticeBanner from '../../../../components/designe/warning-notice-banner/WarningNoticeBanner';
import { useRegisterPageContainerError } from '../../../../components/layout/page-container/page-container-error-handler';
import { useRegisterPageRefreshHandler } from '../../../../components/layout/page-container/page-refresh-handler';
import { useGetUserTrainingAccessIncoming } from '../../../../redux/api/userTrainingAccessApi';
import TrainingList from '../training-list/TrainingList';
import { useFromMeTrainingsPage } from './useFromMeTrainingsPage';

const FromMeTrainings = () => {
  const { t } = useTranslation();
  const { trainings, isLoading, refetchAll, filter, setFilter, error } =
    useFromMeTrainingsPage();
  const {
    data: accessData,
    isLoading: isAccessLoading,
    isFetching: isAccessFetching,
  } = useGetUserTrainingAccessIncoming();
  const isDataLoading = isLoading || isAccessLoading || isAccessFetching;
  const showAccessWarning =
    !isDataLoading &&
    trainings !== null &&
    trainings.length === 0 &&
    (accessData?.createTraining?.length ?? 0) === 0;

  useRegisterPageRefreshHandler(refetchAll);
  useRegisterPageContainerError({
    errors: error ? [error] : [],
    isLoading: isDataLoading,
    hasData: Boolean(trainings?.length),
    onRetry: refetchAll,
  });

  return (
    <TrainingList
      listKind="fromMe"
      trainings={trainings}
      searchValue={filter}
      onSearchChange={setFilter}
      isLoading={isDataLoading}
      showAvatar={true}
      onTrainingDeleted={refetchAll}
      emptyStateBanner={
        showAccessWarning ? (
          <WarningNoticeBanner title={t('trainings.fromMeEmptyBannerTitle')}>
            {t('trainings.fromMeEmptyBannerDescription')}
          </WarningNoticeBanner>
        ) : null
      }
    />
  );
};

export default FromMeTrainings;
